const Settings = () => {
    return <h2>Settings Page</h2>
  }
  export default Settings

  